"use client"
import React from "react"
import classes from "./FloatingBanner.module.scss"
import SalesForceBookingModal from "@/components/Modal/SalesForceBookingModal"

const FloatingBanner = ({ bookMeetingData }) => {
  const [modalIsOpen, setIsOpen] = React.useState(false)

  const { bannerDescription, ...bookMeetingDataForModal } = bookMeetingData

  function openModal() {
    setIsOpen(true)
  }

  function closeModal() {
    setIsOpen(false)
  }
  return (
    <div className={classes.FloatingBanner}>
      <SalesForceBookingModal
        bookMeetingData={bookMeetingDataForModal}
        modalIsOpen={modalIsOpen}
        openModal={openModal}
        closeModal={closeModal}
      />
      <a onClick={openModal} className={classes.highlight}>
        Book A Meeting
      </a>
      &nbsp;{bookMeetingData.bannerDescription}
    </div>
  )
}

export default FloatingBanner
